export default __webpack_public_path__ + "static/howitworks_2-7cfc204337574016d75384271b2ce15f.webp";